export type SanitizeKeywordsOptions = {
    maxLength?: number
}

const DEFAULT_MAX_LENGTH = 100

function containsAlphanumeric(str: string): boolean {
    return /[a-zA-Z0-9]/.test(str)
}

export function sanitizeKeywords(
    keywords: string[] | null | undefined,
    options?: SanitizeKeywordsOptions,
): string[] | null {
    if (keywords == null) return null

    const maxLength = options?.maxLength ?? DEFAULT_MAX_LENGTH
    const seen = new Set<string>()
    const result: string[] = []

    for (const keyword of keywords) {
        const trimmed = keyword.trim()

        // reject empty
        if (trimmed.length === 0) continue

        // reject no-alphanumeric (just symbols/punctuation)
        if (!containsAlphanumeric(trimmed)) continue

        // reject over-maxLength
        if (trimmed.length > maxLength) continue

        // lowercase
        const normalized = trimmed.toLowerCase()

        // deduplicate
        if (seen.has(normalized)) continue
        seen.add(normalized)

        result.push(normalized)
    }

    return result.length > 0 ? result : null
}
